import React from 'react';
import LocationTemplate from './LocationTemplate';

const WanchesePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Wanchese"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27981"]}
      latitude={35.8485}
      longitude={-75.6446}
      population={949}
      historicalFact="Named after Wanchese, a Native American who met the early English explorers; major fishing village."
      nearbyTowns={[
        "Manteo, NC",
        "Nags Head, NC",
        "Kill Devil Hills, NC",
        "Kitty Hawk, NC",
        "Oregon Inlet, NC",
        "Rodanthe, NC",
        "Dare County, NC",
        "Roanoke Island, NC"
      ]}
    />
  );
};

export default WanchesePage;